import { Component, OnInit } from '@angular/core';
import { IssueService } from '../../issue.service';

import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Contact } from '../../issue.model';

@Component({
  selector: 'app-contactus',
  templateUrl: './contactus.component.html',
  styleUrls: ['./contactus.component.css'],
})
export class ContactusComponent implements OnInit {
  currentCode = '';

  currentInput = '';
  resolved(captchaResponse: string) {
    console.log(`Resolved captcha with response: ${captchaResponse}`);
  }
  createForm: FormGroup;

  constructor(private issueService: IssueService, private fb: FormBuilder) {
    this.createForm = this.fb.group({
      name: '',
      mail: '',
      phone: '',
      subject: '',
      message: '',
    });
  }

  addContact(name, email, phone, subject, message) {
    this.issueService
      .addContactus(name, email, phone, subject, message)
      .subscribe(() => {
        console.log('submitted');
      });
  }
  ngOnInit(): void {}
  onCountryChange(event) {
    console.log(event);
  }

  hasError(event) {
    console.log(event);
  }
  getNumber(event): string {
    console.log(event);
    return '1234567';
  }

  telInputObject(event) {}
}
